<template>
    <div class="english-container">
  
      <h2>Jedes Produkt kann nur mit einem Gerät gekoppelt werden.</h2>
  
      <h1>Schnellstart</h1>
      <h2>IOS:</h2>
  
      <ol>
        <li>Schalten Sie die Smart-Karte ein.</li>
        <li>Öffnen Sie die „Find My“-App und tippen Sie auf „+“.</li>
        <li>Wählen Sie „Anderes Objekt hinzufügen“.</li>
        <li>Tippen Sie auf „Verbinden“.</li>
        <li>Folgen Sie den Anweisungen auf dem Bildschirm, um die Verbindung abzuschließen.</li>
      </ol>
  
      <div class="divider"></div>
  
      <h2>Ihr Objekt finden <span>03</span></h2>
  
      <h3>1. Item Locator finden, wenn er sich in der Nähe befindet</h3>
  
      <p>
        Öffnen Sie die Find My-App und wählen Sie den Reiter „Objekte“.
        Tippen Sie in der Liste auf Ihren Item Locator.
        Tippen Sie auf „Ton abspielen“, damit Ihr Item Locator einen Signalton ausgibt.
        Tippen Sie auf „Ton stoppen“, sobald Sie Ihr Objekt gefunden haben.
      </p>
  
      <h3>2. Letzten bekannten Standort des Item Locators finden</h3>
  
      <p>
        Öffnen Sie die Find My-App und wählen Sie den Reiter „Objekte“.
        Tippen Sie in der Liste auf Ihren Item Locator.
        Der zuletzt bekannte Standort Ihres Item Locators wird auf der Karte angezeigt.
      </p>
  
      <div class="divider"></div>
  
      <h2>Objekt außerhalb der Reichweite finden <span>04</span></h2>
  
      <h3>1. „Benachrichtigen, wenn zurückgelassen“ aktivieren</h3>
  
      <p>
        Öffnen Sie die Find My-App und wählen Sie den Reiter „Objekte“.
        Tippen Sie in der Liste auf Ihren Item Locator.
        Aktivieren Sie unter „Benachrichtigungen“
        die Option „Benachrichtigen, wenn zurückgelassen“.
      </p>
  
      <h3>2. „Benachrichtigen, wenn gefunden“ aktivieren</h3>
  
      <p>
        Aktivieren Sie unter Benachrichtigungen
        die Option „Benachrichtigen, wenn gefunden“.
        Wenn Ihr Objekt von einem anderen Find My-fähigen Gerät erkannt wird,
        erhalten Sie eine Benachrichtigung mit dem aktualisierten Standort.
      </p>
  
      <div class="divider"></div>
  
      <h2>Wenn Ihr Objekt verloren geht <span>05</span></h2>
  
      <p>
        Öffnen Sie die Find My-App und wählen Sie den Reiter „Objekte“.
        Tippen Sie in der Liste auf Ihren Item Locator.
      </p>
  
      <p>
        Tippen Sie im „Verloren-Modus“ auf „Aktivieren“.
        Ein Bildschirm mit Informationen zum Verloren-Modus wird angezeigt.
        Tippen Sie auf „Weiter“ und geben Sie Ihre Telefonnummer oder E-Mail-Adresse ein.
      </p>
  
      <div class="divider"></div>
  
      <h2>Zurücksetzen Ihres Item Locators <span>06</span></h2>
  
      <h3>1. Entfernen Sie den Item Locator aus Find My</h3>
  
      <p>
        Öffnen Sie die Find My-App und wählen Sie den Reiter „Objekte“.
        Tippen Sie in der Liste auf Ihren Item Locator.
        Stellen Sie sicher, dass der „Verloren-Modus“ deaktiviert ist.
        Scrollen Sie nach unten und tippen Sie auf „Objekt entfernen“.
      </p>
  
      <h3>2. Werkseinstellungen wiederherstellen</h3>
  
      <p>
        Nachdem Sie den Item Locator erfolgreich aus Find My entfernt haben,
        drücken Sie viermal schnell die Funktionstaste
        und halten Sie sie anschließend beim fünften Mal gedrückt,
        bis ein Klingelton ertönt.
      </p>
  
      <div class="divider"></div>
  
      <h2>Aber warten Sie... Es gibt noch mehr <span>07</span></h2>
  
      <h3>1. Laden</h3>
  
      <p>
        Verwenden Sie ein standardmäßiges kabelloses Ladegerät,
        um das Produkt drahtlos aufzuladen.
        Das rote Licht leuchtet während des Ladevorgangs dauerhaft
        und erlischt, sobald der Akku vollständig geladen ist.
      </p>
  
      <h3>2. Erkennung unerwünschter Verfolgung</h3>
  
      <p>
        Wenn Ihr Telefon einen unbekannten Item Locator erkennt,
        der sich mit Ihnen bewegt, erhalten Sie eine Benachrichtigung.
      </p>
  
      <div class="divider"></div>
  
      <h2>Wichtige Hinweise</h2>
  
      <p class="small">
        Dieses Gerät entspricht Teil 15 der FCC-Bestimmungen.
        Der Betrieb unterliegt den folgenden zwei Bedingungen:
      </p>
  
      <ol class="small">
        <li>Dieses Gerät darf keine schädlichen Störungen verursachen.</li>
        <li>
          Dieses Gerät muss alle empfangenen Störungen akzeptieren,
          einschließlich solcher, die einen unerwünschten Betrieb verursachen können.
        </li>
      </ol>
  
      <p class="small">
        HINWEIS:
        Der Hersteller übernimmt keine Verantwortung für Radio- oder Fernsehstörungen,
        die durch nicht autorisierte Änderungen oder Modifikationen an diesem Gerät verursacht werden.
        Solche Änderungen können die Berechtigung des Benutzers zum Betrieb des Geräts ungültig machen.
      </p>
  
      <p class="small">
        Dieses Gerät wurde geprüft und erfüllt die allgemeinen Anforderungen
        zur HF-Exposition.
        Das Gerät kann ohne Einschränkungen unter tragbaren Bedingungen verwendet werden.
      </p>
  
      <p class="small">
        Dieses Gerät wurde getestet und entspricht den Grenzwerten
        für digitale Geräte der Klasse B gemäß Teil 15 der FCC-Bestimmungen.
      </p>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'CardGermanLanguage',
  };
  </script>
  
  <style scoped>
  
  .english-container{
    background-color:#ffffff;
    border-radius:8px;
    padding:30px;
    margin:10px auto;
    max-width:1000px;
    box-shadow:0 2px 8px rgba(0,0,0,0.08);
  }
  
  h1{
    font-size:42px;
    margin-bottom:25px;
    color:#222;
    text-align:left;
  }
  
  h2{
    font-size:28px;
    margin-top:35px;
    margin-bottom:15px;
    color:#222;
    text-align:left;
  }
  
  h3{
    font-size:20px;
    margin-top:24px;
    margin-bottom:10px;
    color:#333;
    text-align:left;
  }
  
  p{
    font-size:15px;
    line-height:1.8;
    color:#333;
    text-align:left;
    margin-bottom:14px;
  }
  
  ol{
    padding-left:24px;
    margin-bottom:20px;
  }
  
  li{
    font-size:15px;
    line-height:1.8;
    color:#333;
    margin-bottom:10px;
    text-align:left;
  }
  
  .small{
    font-size:13px;
    line-height:1.7;
  }
  
  .divider{
    width:100%;
    height:1px;
    background:#e5e5e5;
    margin:40px 0;
  }
  
  span{
    color:#888;
    font-weight:700;
  }
  
  .image_1{
    width:90%;
    max-width:600px;
    height:auto;
    margin:20px auto;
    display:block;
    border-radius:8px;
  }
  
  @media (max-width:768px){
  
    .english-container{
      padding:20px;
    }
  
    h1{
      font-size:32px;
    }
  
    h2{
      font-size:24px;
    }
  
    h3{
      font-size:18px;
    }
  
    p, li{
      font-size:14px;
    }
  }
  
  </style>